// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"GV-z","sponsoredTooltipWrapper":"HV-z","sponsoredTooltip":"IV-z","newCard":"JV-z"};